import { LANGUAGE_CONFIG } from '@/configured/languages/config';

const STORAGE_KEY = 'mercury.pkp.activeLocale';

/**
 * @returns {string|null} A key from LANGUAGE_CONFIG, or null
 */
export function readStoredLocale() {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw || !String(raw).trim()) {
      return null;
    }
    const code = String(raw).trim();
    return LANGUAGE_CONFIG[code] ? code : null;
  } catch {
    return null;
  }
}

/**
 * @param {string} lang A key from LANGUAGE_CONFIG
 */
export function writeStoredLocale(lang) {
  if (typeof localStorage === 'undefined' || !lang) {
    return;
  }
  if (!LANGUAGE_CONFIG[lang]) {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // Private mode, quota, etc.
  }
}
